export default "__VITE_ASSET__c8c47ba6__"